import { Environment as InternalEnvironment } from '@policyfly/protobuf/pfinternal'

import type { Environment as BingoEnvironment } from '@policyfly/protobuf/pfbingo'

export function bingoEnvironmentToInternalEnvironment (environment?: BingoEnvironment | null): InternalEnvironment {
  switch (environment?.name) {
    case 'local':
      return InternalEnvironment.ENVIRONMENT_LOCAL
    case 'dev':
      return InternalEnvironment.ENVIRONMENT_DEV
    case 'stage':
      return InternalEnvironment.ENVIRONMENT_STAGE
    case 'bugfix':
      return InternalEnvironment.ENVIRONMENT_BUGFIX
    case 'prod':
      return InternalEnvironment.ENVIRONMENT_PROD
    default:
      return InternalEnvironment.ENVIRONMENT_UNSPECIFIED
  }
}
